import apiClient from '@shared/services/apiClient';
import type { ClinicNote } from '../types/note';

/**
 * Client for the polymorphic Notes endpoint, scoped to clinic-level notes.
 * Notes reference a clinic via referenceTable='Clinics' + referenceId=clinicId.
 */
const CLINIC_REFERENCE_TABLE = 'Clinics';

export const notesApi = {
  getClinicNotes: async (clinicId: number): Promise<ClinicNote[]> => {
    const response = await apiClient.get('/notes', {
      params: { referenceTable: CLINIC_REFERENCE_TABLE, referenceId: clinicId },
    });
    return response.data;
  },

  createClinicNote: async (clinicId: number, noteText: string): Promise<{ id: number }> => {
    const response = await apiClient.post('/notes', {
      referenceTable: CLINIC_REFERENCE_TABLE,
      referenceId: clinicId,
      noteText,
      noteType: 'General',
    });
    return response.data;
  },

  deleteNote: async (noteId: number): Promise<void> => {
    await apiClient.delete(`/notes/${noteId}`);
  },
};
